
import {IListingTypology} from "@wikicasa/common/model/ListingTypology";
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
//@ts-ignore
import {useListingTypologyMultiselect} from "@wkComposables/useListingTypologyMultiselect";

import {Dropdown} from "bootstrap";
import {defineComponent, PropType} from "vue";
import {Nullable} from "@customTypes/CustomUtilityTypes";

export default defineComponent({
    name: "ListingTypologyMultiSelect",
    components: {CheckboxBtn},
    props: {
        ltmsBtnClasses: {type: String, default: ""},
        modelValue: {
            type: Array as PropType<Array<number>>,
        },
        listingTypologies: {
            type: Array as PropType<Array<IListingTypology>>,
        },
        macroTypologyId: {
            type: Number
        },
        macroTypologyIdList: {
            type: Array as PropType<Nullable<Array<number>>>
        },
        name: {
            type: String
        },
        // To know if we are in the listing page or not
        listing: {
            type: Boolean,
        },
        arrowColor: {
            type: String
        },
        forceClose: {
            type: Boolean
        }
    },
    emits: ["dropdown-closed", "click", "input-object"],
    setup(props, context){
        const {
            //state
            selectedDTO,
            groups,
            originalLabel,
            //computed
            labels, selectedLabel,
            //methods
            decodeTextWithEntities,
            updateSelected,
            updateLabelAndIcon,
            generateGroups,
            getListingTypologyById,
            manageListingTypology,
            addListingTypology,
            isSelected,
            confirm,
            noGroupTypologiesIdList
        } = useListingTypologyMultiselect(context.emit)

        return {
            //state
            selectedDTO,
            groups,
            originalLabel,
            //computed
            labels, selectedLabel,
            decodeTextWithEntities,
            //methods
            updateSelected,
            updateLabelAndIcon,
            generateGroups,
            getListingTypologyById,
            manageListingTypology,
            addListingTypology,
            isSelected,
            confirm,
            noGroupTypologiesIdList
        }
    },
    watch: {
        modelValue(curListingTypologyIdList, prevListingTypologyIdList) {
            if (curListingTypologyIdList?.length === 1 && curListingTypologyIdList[0] === 0) {
                this.updateSelected(this.modelValue, this.listingTypologies, this.macroTypologyId, this.macroTypologyIdList);
            } else if (curListingTypologyIdList?.length === 0) {
                const previousListingTypology = this.getListingTypologyById(this.listingTypologies, prevListingTypologyIdList[0] || 0);

                if (this.noGroupTypologiesIdList(this.listingTypologies).find((id: number) => id === previousListingTypology.listingTypologyId)) {
                    this.addListingTypology(this.listingTypologies[0]);
                    this.selectedDTO.group = this.listingTypologies[0].group;
                } else {
                    this.addListingTypology(this.listingTypologies[previousListingTypology.macroTypologyID - 1]);
                    this.selectedDTO.group = previousListingTypology.group;
                }

                this.confirm(false, true, this.listingTypologies);
            }
        },
        forceClose(cur) {
            //SHAME ON ME!
            if (cur) {
                const dropDown = this.$refs.dropdownToggle as HTMLElement;
                const dropdownMenu = this.$refs.dropdownMenu as HTMLElement;
                if (dropDown?.classList.contains("show"))
                    dropDown?.classList.remove("show");
                if (dropdownMenu?.classList.contains("show"))
                    dropdownMenu?.classList.remove("show")

                this.$emit("dropdown-closed");
            }
        }
    },
    created() {
        this.generateGroups(this.listingTypologies);
        this.updateSelected(this.modelValue, this.listingTypologies, this.macroTypologyId, this.macroTypologyIdList);
    },
    mounted() {
        this.updateLabelAndIcon(this.listingTypologies);
        this.originalLabel = this.selectedDTO.label;
        document.body.addEventListener("click", this.onClickHandler);
        //BRAH
        //Per rimuover il flip del dropdown, capita se si è degli gnomi con un'altezza di finestra gnoma
        const drp = this.$refs.dropdownToggle as HTMLElement;
        const dropdown = new Dropdown(drp, {
            popperConfig: {
                modifiers: [{
                    name: "flip",
                    enabled: false
                }]
            }
        })
    },
    unmounted(): void {
        //If this component is destroyed (in vue3 the state is unmounted), we have to clean up the listeners added
        //in this component and the global select
        window.opened_select = undefined;
        document.body.removeEventListener("click", this.onClickHandler)
    },
    methods: {
        onClickHandler(event: Event) {
            const dropDownMenu = this.$refs.dropdownMenu as HTMLElement;
            if (dropDownMenu?.classList.contains("show")) {
                this.confirm(true);
            }
        },
        isGroupIdSelected(id: number): boolean {
            return id === this.selectedDTO.macroTypologyID && this.selectedDTO.selectedListingTypologies[0].group !== "";
        },

    }
})
